import { CustomFieldText } from "components/StackCustom/styles";

interface FilterColumnProps {
  label: string;
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  value?: string;
  inputRef?: React.Ref<any> | undefined;
}

export function FilterColumn({
  label,
  name,
  onChange,
  value,
  inputRef,
}: FilterColumnProps) {
  const inputProps = value !== undefined
    ? { value }
    : { defaultValue: "" };

  return (
    <CustomFieldText
      variant="standard"
      label={label}
      type="text"
      name={name}
      {...inputProps}
      onChange={onChange}
      onKeyDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      inputRef={inputRef}
    />
  );
}
